import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from '@mui/material';

import type { ChildApplyJson } from '@/types/domain/childApply/entities/childApplyEntity';

import DialogTitle from '@/components/DialogTitle';
import DialogTransition from '@/components/DialogTransition';
import ChildApplyInfo from '@/domain/childApply/component/ChildApplyInfo';

/**
 * プロパティ
 */
export type ApplyConfirmImput = {
  /** データ */
  data: ChildApplyJson | undefined,
  /** 適用する */
  onApply: (input: ChildApplyJson | undefined) => void,
}

const ApplyConfirm: React.FC<ApplyConfirmImput> = ({ data, onApply }) => (
  <Dialog
    open={data !== undefined}
    onClose={() => onApply(undefined)}
    fullScreen
    TransitionComponent={DialogTransition}
  >
    <DialogTitle title="登録申請" />
    <DialogContent>
      <p>申請内容を確認し問題なければ、「申請する」ボタンを押してください。</p>
      {data && <ChildApplyInfo data={data} />}
    </DialogContent>
    <DialogActions>
      <Button variant="contained" onClick={() => onApply(data)} color="primary">
        申請する
      </Button>
      <Button variant="contained" onClick={() => onApply(undefined)} color="primary">
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
);

export default ApplyConfirm;
